import { CheckIcon, InfoIcon, WarnIcon } from "@/components/icons";
import { dateLabel, money } from "@/utils/format";

export function IneligibleScreen() {
  return (
    <section className="screen-enter" data-testid="screen-ineligible">
      <h2>A migração ainda não está disponível pra você</h2>
      <p className="lpc-sub">
        O Vammo Conquista está em fase de testes com um grupo limitado de clientes. Quando abrir
        pra todo mundo, a gente divulga pra todos os nossos clientes.
      </p>
      <div className="lpc-note">
        <InfoIcon />
        <span>Sua assinatura atual continua valendo normalmente — nada muda.</span>
      </div>
    </section>
  );
}

/* Residual screen: the backend un-sticks legacy CX_REVIEW records on status
   reads (PM 2026-07-21), so this only shows on backend/LP version skew. Copy
   per Jerry (Slack 2026-07-21): pending payment + a way forward, never "the
   team will contact you". */
export function CxReviewScreen({
  entryDue,
  onPayNow,
}: {
  entryDue: number | null;
  onPayNow: () => void;
}) {
  return (
    <section className="screen-enter" data-testid="screen-cx-review">
      <h2>Falta um detalhe — e a gente resolve com você</h2>
      <p className="lpc-sub">
        O pagamento da caução do Vammo Conquista ainda está pendente na sua conta.
        {entryDue ? (
          <>
            {" "}
            Falta <strong data-testid="cx-pending-value">{money(entryDue)}</strong>.
          </>
        ) : null}{" "}
        Você deve realizar o pagamento para continuar com a mudança.
      </p>
      <button className="btn btn--primary" data-testid="cx-pay-now" onClick={onPayNow}>
        Pagar agora
      </button>
      <div className="lpc-warn">
        <InfoIcon />
        <span>
          Sua assinatura atual segue valendo e sua migração para o Vammo Conquista só continuará
          após o pagamento da caução.
        </span>
      </div>
    </section>
  );
}

export function ErrorScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <section className="screen-enter" data-testid="screen-error">
      <h2>Deu ruim aqui do nosso lado</h2>
      <p className="lpc-sub">Não foi possível carregar suas informações. Tenta de novo em instantes.</p>
      <button className="btn btn--primary" data-testid="error-retry" onClick={onRetry}>
        Tentar de novo
      </button>
      <p className="lpc-micro">Se continuar, chama a gente no WhatsApp de sempre.</p>
    </section>
  );
}

export function DoneKeepScreen({
  firstName,
  effectiveTermMonths,
}: {
  firstName: string | null;
  effectiveTermMonths: number | null;
}) {
  return (
    <section className="screen-enter" data-testid="screen-done-keep">
      <div className="lpc-check">
        <CheckIcon />
      </div>
      <h2>Conquista ativada{firstName ? `, ${firstName}` : ""}!</h2>
      <p className="lpc-sub">
        Sua assinatura já é Vammo Conquista.
        {effectiveTermMonths ? (
          <>
            {" "}
            Em <strong>{effectiveTermMonths} meses</strong> a moto passa pro seu nome.
          </>
        ) : null}
      </p>
      <div className="lpc-card">
        <ul className="lpc-benefits">
          <li>Contrato assinado — cópia enviada pro seu email</li>
          <li>A nova semanal já aparece na sua próxima fatura, com o ajuste proporcional</li>
          <li>Sua moto, sua rede de troca, seu atendimento: tudo igual</li>
        </ul>
      </div>
      <p style={{ fontWeight: 800, fontSize: 17 }}>Bora rodar. Cada semana agora é sua conquista.</p>
    </section>
  );
}

export function DoneChangeScreen({
  date,
  stationName,
  stationAddress,
  onReschedule,
}: {
  date: string;
  stationName: string;
  stationAddress: string | null;
  onReschedule: (() => void) | null;
}) {
  return (
    <section className="screen-enter" data-testid="screen-done-change">
      <div className="lpc-check">
        <CheckIcon />
      </div>
      <h2>Troca agendada!</h2>
      <div className="lpc-card lpc-card--hero">
        <div className="lpc-price" data-testid="done-date">
          {dateLabel(date)}
        </div>
        <p style={{ fontWeight: 700, marginBottom: 8 }} data-testid="done-unit">
          {stationName}
          {stationAddress ? ` — ${stationAddress}` : ""}
        </p>
        <p className="lpc-micro" style={{ marginTop: 0 }}>
          Sem hora marcada — chega no dia e procura o atendimento. Leva sua moto atual e sua CNH.
        </p>
      </div>
      <div className="lpc-warn">
        <WarnIcon />
        <span>Atendimento só nesse dia. Sem encaixe em outra data.</span>
      </div>
      <div className="lpc-card lpc-card--muted">
        <ul className="lpc-benefits">
          <li>Você troca sua moto pela Comfort 0km na base</li>
          <li>Nosso time ativa seu plano Conquista na hora da troca</li>
          <li>Contrato assinado já está no seu email</li>
        </ul>
      </div>
      {onReschedule ? (
        <button className="btn--link" data-testid="reschedule" onClick={onReschedule}>
          Preciso trocar a data
        </button>
      ) : null}
    </section>
  );
}
